// Overlays that cover the whole viewport (the "Richtig!" flash, the solved screen,
// the pinned CTAs, the map hint) must center their content in the visible content
// area, not under the sidebar. The sidebar is 300px when expanded, a narrow rail when
// collapsed and on top of the content on phones, so this keeps --tc-content-left on
// <body> in sync with the space it takes on the left (0 when it is not a side rail).

let observed: Element | null = null;

function update(): void {
	const rect = observed?.getBoundingClientRect();
	// a side rail runs the full height next to the content; on phones the sidebar is the top bar
	const left = rect && rect.width > 0 && rect.height >= window.innerHeight - 1 && rect.width < window.innerWidth / 2
		? Math.round(rect.right)
		: 0;

	if (left > 0) {
		document.body.style.setProperty('--tc-content-left', `${left}px`);
	} else {
		document.body.style.removeProperty('--tc-content-left');
	}
}

const resizeObserver = new ResizeObserver(update);

// Blazor renders the layout (and so the sidebar) after the page loaded, and re-renders it
function sync(): void {
	const sidebar = document.querySelector('.singha-sidebar');
	if (sidebar === observed) {
		return;
	}

	if (observed) {
		resizeObserver.unobserve(observed);
	}

	observed = sidebar;
	if (sidebar) {
		resizeObserver.observe(sidebar);
	}

	update();
}

function start(): void {
	new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
	window.addEventListener('resize', update);
	sync();
}

export function initContentInset(): void {
	if (document.body) {
		start();
	} else {
		document.addEventListener('DOMContentLoaded', start);
	}
}
